export default "__VITE_ASSET__vDyfr8on__"